export default __webpack_public_path__ + "static/media/oc_blog.06b45732.jpg";